@if (messageService.messages.length) {
  <div>
    @switch (messageService.level) {
      @case ('error') {
        <div class="govuk-error-summary" aria-labelledby="error-summary-title" role="alert" tabindex="-1" data-module="govuk-error-summary">
          <h2 class="govuk-error-summary__title" id="error-summary-title">
            There is a problem
          </h2>
          <div class="govuk-error-summary__body">
            <ul class="govuk-list govuk-error-summary__list">
              @for (message of messageService.messages; track message) {
                <div>
                  <li> {{message}} </li>
                </div>
              }
            </ul>
          </div>
        </div>
      }
      @default {
        <div class="messages govuk-inset-text">
          @for (message of messageService.messages; track message) {
            <span> {{message}} </span>
          }
          <!--button class="clear"
        (click)="messageService.clear()">clear</button-->
      </div>
    }
  }
</div>
}
